import { render, staticRenderFns } from "./olPlace.vue?vue&type=template&id=1f4de794&scoped=true"
import script from "./olPlace.vue?vue&type=script&lang=js"
export * from "./olPlace.vue?vue&type=script&lang=js"
import style0 from "./olPlace.vue?vue&type=style&index=0&id=1f4de794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4de794",
  null
  
)

export default component.exports